import { MDSDrawer } from '@midwest/web/drawer';
import { tablet } from '@thrivent/midwest-shared';
import { MDSAnchorButton, MDSButton } from '@thrivent/midwest-web';
import styled from 'styled-components';

export const AdvicePageHeroSectionStyles = {
  ButtonTrigger: styled(MDSButton)`
    width: 100%;
    margin-top: 1.5rem;
    text-decoration: none;

    ${tablet} {
      width: fit-content;
      display: inline-flex;

      :not(:last-of-type) {
        margin-right: 1rem;
      }
    }
  `,
  Drawer: styled(MDSDrawer)``,
  // TODO: remove this once feature flag (Show working-with-us flyout) is removed
  Button: styled(MDSAnchorButton)`
    width: 100%;
    margin-top: 1.5rem;
    text-decoration: none;

    ${tablet} {
      width: fit-content;
      display: inline-flex;

      :not(:last-of-type) {
        margin-right: 1rem;
      }
    }
  `,
};
